import React, { createContext, useContext, useState, useEffect } from "react";
import api from "@/lib/api";

const SettingsContext = createContext(null);

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);

  const load = async () => {
    try {
      const res = await api.get("/company");
      setSettings(res.data);
    } catch (e) {}
  };

  useEffect(() => { load(); }, []);

  return (
    <SettingsContext.Provider value={{ settings: settings || {}, reload: load }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);
